// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3R5Ih","box":"WorkspacesBox_box__2Qtfp","node":"WorkspacesBox_node__xdF0Y"};